import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76610541"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chooseTeam h-full flex flex-col" }
const _hoisted_2 = { class: "conten flex flex-col" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "选择班组", -1))
const _hoisted_4 = { class: "content_list content-start scrollBar" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "team-name text-white font-medium title-text" }
const _hoisted_7 = { class: "people" }
const _hoisted_8 = {
  key: 0,
  class: "triangle"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://djcps.oss-cn-hangzhou.aliyuncs.com/pro/djmes/select.png",
  alt: ""
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_12 = { class: "footer flex justify-between items-center w-full text-center" }

import { ref, onMounted, reactive } from "vue";
import API, { IGetMachineTeamGetMachineBindListVo, IGetMachineTeamGetSimpleTeamUserListVo, IPostMachineTeamBindTeamBo } from "@/api/peopleTeam"
import { message } from "ant-design-vue";
import { storage } from "../constant/index";
import { intoMain, getMqttConnectInfor } from "@/constant/index";

//定义回调事件

export default /*#__PURE__*/_defineComponent({
  __name: 'chooseTeam',
  emits: ['backClick'],
  setup(__props, { emit }) {



onMounted(() => {
    //生命周期处理内容
    getlist()
});
let activeIndedx: any = ref(storage.getTeamId('teamId') ? JSON.parse(JSON.stringify(storage.getTeamId('teamId'))).teamId : '')
const LoginUserId = ref(localStorage.getItem("userId"))
const userId = ref(storage.getTeamId('teamId') ? JSON.parse(JSON.stringify(storage.getTeamId('teamId'))).userId : '')
let activeStyle: any = ref({
    borderWidth: "1px",
    borderStyle: 'solid',
    borderColor: '#13C2C2',
})
let tableList = ref<IGetMachineTeamGetSimpleTeamUserListVo[]>([])
let loading = ref<boolean>(false)
let parmas = reactive<IPostMachineTeamBindTeamBo>({
    teamId: null,
    machineId: null
})
let equimentParmas = ref<IGetMachineTeamGetMachineBindListVo>(storage.getNewMachineId('NewmachineId'))
let clickData = ref(storage.getTeamId('teamId') ? JSON.parse(JSON.stringify(storage.getTeamId('teamId'))) : {})
// ---------------------方法定义-------------------------
const getlist = () => {
    API.getMachineTeamGetSimpleTeamUserList({ machineId: equimentParmas.value.id }).then(res => {
        tableList.value = res.list
        if (storage.getTeamId('teamId') && JSON.parse(JSON.stringify(storage.getTeamId('teamId'))).teamId) {
            res.list.map(item => {
                if (item.teamId == JSON.parse(JSON.stringify(storage.getTeamId('teamId'))).teamId) {
                    parmas.teamId = JSON.parse(JSON.stringify(storage.getTeamId('teamId'))).teamId
                }
            })
        }
    })
}
const chooseTeam = function (item: any) {
    if (!userId.value) {
        userId.value = LoginUserId.value
    }
    activeIndedx.value = item.teamId
    clickData.value = item
    parmas.teamId = item.teamId
};
//返回上一步
const back = () => {
    emit('backClick', true)
}
//主页切换班组取消
const cancel = () => {
    intoMain()
}
//确定进入主页面
const sure = () => {
    loading.value = true
    parmas.machineId = equimentParmas.value.id
    API.postMachineTeamBindTeam(parmas).then((res) => {
        clickData.value['userId'] = localStorage.getItem('userId')
        equimentParmas.value['userId'] = localStorage.getItem('userId')
        storage.set('teamId', clickData.value)
        storage.set('machineId', equimentParmas.value)
        localStorage.removeItem('pageName');
        message.success({ content: "机台和班组绑定成功", });
        getMqttConnectInfor()
        intoMain()
    }).catch(err => {
        loading.value = false
    })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: ($event: any) => (chooseTeam(item)),
            style: _normalizeStyle(_unref(activeIndedx) == item.teamId && LoginUserId.value == userId.value ? _unref(activeStyle) : '')
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.teamName), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.userList), 1),
            (_unref(activeIndedx) == item.teamId && LoginUserId.value == userId.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
              : _createCommentVNode("", true)
          ], 12, _hoisted_5))
        }), 128)),
        _hoisted_11
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.$router.currentRoute.value.query && _ctx.$router.currentRoute.value.query.key == '2')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "btn cancle",
            onClick: cancel
          }, "取消"))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "btn cancle",
            onClick: back
          }, "上一步")),
      _createVNode(_component_a_button, {
        type: "primary",
        loading: _unref(loading),
        disabled: !(_unref(tableList).length > 0 && _unref(parmas).teamId),
        class: "btn next",
        onClick: sure
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认")
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ]))
}
}

})